import React, { useContext, useEffect, useRef, useState } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { lightGreen } from '@mui/material/colors';
import Globalcontext from '../../Context/Globalcontext';
import Cowsmall from "../../imgs/cowsmall.gif";
import Grass from "../../imgs/grass.png";
import { LanRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

// Register the font using the imported variable
Font.register({
    family: 'Lato-Italic',
    src: LatoItalicFont,
});

Font.register({
    family: "Kannada",
    src: NotoSansKannada,
});


const Billtapshil = (props) => {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const [customerData, setCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [loadedPages, setLoadedPages] = useState(1);
    let bothornotmain = "";


    const loadMorePages = () => {
        setIsLoading(true);
        const pagesToLoad = 1; // Change this to load more pages

        setTimeout(() => {
            setLoadedPages(loadedPages + pagesToLoad);
            setIsLoading(false);
        }, 1000);
    };

    useEffect(() => {
        console.log(localStorage.getItem("customerData"));
        setTimeout(() => {

            if (JSON.parse(localStorage.getItem("customerData"))) {
                setCustomerData(JSON.parse(localStorage.getItem("customerData")));
                // Set loading to false when data is ready
                setIsLoading(false);
            }
        }, 200);
    }, []);

    const pageDataLength = parseFloat(Object.keys(customerData).length) / 2;
    const minutes = Math.floor(pageDataLength / 60);
    const seconds = pageDataLength % 60;

    return (
        <div className="billprintmain">
            <PDFViewer className='pdf'>
                <Document>
                    {Object.keys(customerData).map((kno, index) => (
                        <PageTemplate key={index} data={customerData[kno]} index={index} kno={kno} min={minutes} sec={seconds} pages={parseFloat(pageDataLength) * 2} t={t} lang={i18n.language} />
                    ))}
                </Document>
            </PDFViewer>
        </div>
    );
};

function PageTemplate({ data, index, kno, min, sec, pages, t, lang }) {
    const fontBase = lang === "kn" ? "Kannada" : "Lato-Italic";
    const [kapat, setKapat] = useState({});
    const [isGenerating, setIsGenerating] = useState(true);

    const generatePageContent = async () => {
        // Simulate page generation
        await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust the duration as per your page generation time
        setIsGenerating(false); // Set isGenerating to false when the page is ready
    };

    useEffect(() => {
        generatePageContent();
    }, []);


    const getDatesInRange = (date1, date2) => {
        const dates = [];
        const currentDate = new Date(date1);

        while (currentDate <= new Date(date2)) {
            dates.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    };

    const getTableDataWithZeros = (tableData, date1, date2, type, time) => {
        if (!Array.isArray(tableData)) {
            return Array.from({ length: getDatesInRange(date1, date2).length }, (_, index) => ({
                sr: '',
                date: getDatesInRange(date1, date2)[index],
                time: time,
                kno: '',
                type: type,
                liter: '0',
                fat: '0',
                snf: '0',
                rate: '0',
                amt: '0.00',
                date1: date1,
                date2: date2,
                kendra: '',
            }));
        }

        const dateRange = getDatesInRange(date1, date2);
        const tableWithData = [];

        dateRange.forEach(date => {
            const matchingEntry = tableData.find(
                entry => entry.date === date && entry.type === type && entry.time === time
            );

            if (matchingEntry) {
                tableWithData.push(matchingEntry);
            } else {
                // Create a record with zero values
                tableWithData.push({
                    sr: '',
                    date: date,
                    time: time,
                    kno: '',
                    type: type,
                    liter: '0',
                    fat: '0',
                    snf: '0',
                    rate: '0',
                    amt: '0.00',
                    date1: date1,
                    date2: date2,
                    kendra: '',
                });
            }
        });

        return tableWithData;
    };


    const styles = StyleSheet.create({
        page: {
            paddingTop: 10,
            flexDirection: 'row',
            backgroundColor: '#FFFFFF',
            justifyContent: 'center', // Center horizontally
            marginLeft: 14, // Increase the left margin
            marginRight: 13

        },
        pageWithMargin: {
            backgroundColor: "lightblue"
        },
        header: {
            position: 'absolute',
            top: 0, // Adjust this value to change the vertical position
            left: 0,
            right: 0,
            textAlign: 'center',
        },
        loading: {
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center'
        },
        tableContainer: {
            display: 'flex',
            flexDirection: 'row',
            width: '100vw',
            justifyContent: 'space-between',
        },
        table: {
            display: 'table',
            width: 'auto', // Adjust as needed to fit four tables in a row
            margin: 5,
            marginLeft: -1,
        },
        tableone: {
            display: 'table',
            width: '18%', // Adjust as needed to fit four tables in a row
            margin: 5,
        },
        tableCellone: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            flex: 1, // Remove width and use flex to distribute space equally
        },

        tableCellonebig: {
            border: '0.5px solid lightgray',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebig2: {
            border: '0.5px solid #000',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '10px',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebigdata: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '3mm',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableRowone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableRowonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableHeaderone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        tableHeaderonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        allbill: {
            flexDirection: 'row',
            width: '65%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        allbillbig: {
            border: '0.5px solid lightgray',
            flexDirection: 'row',
            width: '80%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        tableRow: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
        },
        tableRow2: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
            marginTop: 5,
            backgroundColor: 'lightgray'
        },
        line: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: 2,
            width: '95vw',
        },
        tableHeader: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '5mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersm: {
            border: '0.5px solid #000',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig2: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig3: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermedbig: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2big: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableCell: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellsm: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell
        },
        tableCellsmamt: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '18mm', // Set the width of the individual cell

        },
        tableCellsmbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell

        },
        tableCellmed: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmedbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmed2: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        tableCellmed2big: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        latoText: {
            fontFamily: fontBase,
            fontSize: 15,
            marginBottom: 5,
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold',
            marginLeft: -15,
            marginTop: 1,
        },
        headtextsmall: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
        },
        headtextsmall2: {
            fontFamily: fontBase,
            fontSize: 14,
            marginLeft: 20,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmall3: {
            fontFamily: fontBase,
            fontSize: 14,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmall4: {
            fontFamily: fontBase,
            fontSize: 10,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmallleft1: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft3: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft4: {
            fontFamily: fontBase,
            fontSize: 9,
            marginRight: -50,
            marginTop: -5,
            fontWeight: 'bold',
        },

        headtextsmallleft1big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },

        row: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
        },
        row1: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 5
        },
        row2: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 140,
            paddingRight: 140,
            backgroundColor: 'lightgray',
        },
        row2both: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 180,
            paddingRight: 180,
            backgroundColor: 'lightgray',
        },
        row2single: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: '250px',
            backgroundColor: 'lightgray',
        },
        column1: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
            border: '0.5px solid black',
        },
        column1noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '23%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
        },
        column2: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5,
            border: '0.5px solid black',

        },
        column2noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5
        },
        column3: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            border: '0.5px solid black',
            marginLeft: 7,
        },
        column3noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            marginLeft: 7,
        },
        column1Row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        column1Rowtap: {
            marginTop: 10,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        column1Rowratib: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
        },
        column1Labelcenter2: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
            alignSelf: 'center',
            textAlign: 'center', // Align labels to the left
        },
        column1Rowratib2: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
            marginBottom: 3
        },
        simplerow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '20%',
        },
        simplecol: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: -1
        },
        column1Rowgray: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: 2,
            marginTop: 1,
            marginBottom: 5,
            border: '0.5px solid black',
            backgroundColor: 'lightgray'
        },
        column1Label: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'left', // Align labels to the left
        },
        textbold: {
            fontFamily: fontBase,
            fontSize: 11,
            fontWeight: 'bold',
            textAlign: 'left', // Align labels to the left
        },
        column1Value: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'right', // Align values to the right
        },
        pageBreak: {
            pageBreakBefore: 'always',
        },
        totalsRow: {
            flexDirection: 'row',
            borderTop: '1px solid #000',
            paddingTop: 5,
            paddingLeft: 2,
        },
        totalsCell: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 8,
            width: 2,
            textAlign: 'center',
        },
        imagerow: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: -7
        },
        image: {
            width: 45, // Adjust the width as needed
            height: "auto", // Maintain aspect ratio
            marginLeft: -5,
            marginTop: 5

        },
        imgtext: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        tableCellgreen: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'green',
            width: 2,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        tableCellred: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'red',
            width: 3,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        loadingSpinner: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 16,
            fontWeight: 'bold',
            color: 'gray',
        },

        khTable: {
            marginTop: 3,
            borderWidth: 1,
            borderColor: '#333',
            width: '80vw'
        },
        khTableHeader: {
            flexDirection: 'row',
            backgroundColor: '#eee',
            borderBottomWidth: 1,
            borderColor: '#333',
        },
        khTableRow: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderColor: '#ddd',
        },
        khCellhe: {
            padding: 4,
            fontSize: 10,
            flexGrow: 1.3,
        },

        khCell: {
            paddingVertical: 4,
            fontSize: 9,
        },
        khtype: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '12%',
            paddingHorizontal: 4,
            textAlign: 'center',
        },
        khDate: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '15%',
            paddingHorizontal: 4,
            textAlign: 'center',
        },
        khName: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '27%',
            paddingHorizontal: 2,    // small padding on left/right
            textAlign: 'left',       // left-align the text
        },
        khQty: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '15%',
            paddingHorizontal: 4,
            textAlign: 'center',
        },
        khRate: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '15%',
            paddingHorizontal: 4,
            textAlign: 'center',
        },
        khAmt: {
            fontFamily: fontBase,
            fontSize: 10,
            width: '20%',
            paddingHorizontal: 4,
            textAlign: 'center',
        },

    });

    const knoData = data;
    const groupByTypeAndTime = {};

    const rawKh = knoData[0].khdetails || '[]';
    const rawAdv = knoData[0].advdetails || '[]';
    let khArray = [], advArray = [];
    try { khArray = JSON.parse(rawKh); } catch (e) { khArray = [] }
    try { advArray = JSON.parse(rawAdv); } catch (e) { advArray = [] }

    let tlitermhmor = 0;
    let tlitermhevn = 0;
    let tlitergaymor = 0;
    let tlitergayevn = 0;

    // Group data by 'type' and 'time'
    knoData.forEach(entry => {
        const key = entry.type + '-' + entry.time;
        tlitermhmor = entry.tlitermhmor;
        tlitermhevn = entry.tlitermhevn;
        tlitergaymor = entry.tlitergaymor;
        tlitergayevn = entry.tlitergayevn;
        if (!groupByTypeAndTime[key]) {
            groupByTypeAndTime[key] = [];
        }
        groupByTypeAndTime[key].push(entry);
    });

    const tableDataArrays = ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey) => {
        const [type, time] = typeTimeKey.split('-');
        const entries = groupByTypeAndTime[typeTimeKey]; // You should define 'groupByTypeAndTime' based on your data structure.
        return getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);
    });

    function formatDate(inputDate) {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(inputDate).toLocaleDateString('en-US', options);
    }


    const calculateSumOfAmtColumns = (tableDataArray) => {
        const sums = Array.from({ length: tableDataArray[0].length }, () => 0); // Initialize an array with zeros based on the length of the first table

        // Loop through the tables and calculate sums for each record
        tableDataArray.forEach((tableDataWithZeros) => {
            tableDataWithZeros.forEach((entry, entryIndex) => {
                sums[entryIndex] += parseFloat(entry.amt);
            });
        });
        return sums;
    };

    const sumsOfAmtColumns = calculateSumOfAmtColumns(tableDataArrays);
    //  console.log("sumsOfAmtColumns: ", sumsOfAmtColumns);
    const sumOfFifthTable = sumsOfAmtColumns.reduce((total, sum) => total + parseFloat(sum), 0).toFixed(2);
    let totalOfTotalLiter = 0;
    let totalOfTotalFat = 0;
    let tkapat = 0;
    let tyene = 0;
    let ada = 0;

    let zeroflagmh = false;
    let zeroflaggay = false;

    let zeroflagmhevn = false;
    let zeroflaggayevn = false;

    let totalLiterMh = 0;
    let totalLiterGay = 0;

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [isboth, setIsboth] = useState(false);

    useEffect(() => {
        if (zeroflagmh && zeroflaggay) {
            //   console.log("in both");
            setIsboth(true);
        }
    }, [zeroflagmh, zeroflaggay]);

    const renderTable = (tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate) => {
        return (
            <View key={typeTimeKey} style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                    {tableIndex == dateflag ? (
                        <Text
                            style={[
                                bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig,
                                { width: bothornot === "both" ? 38 : 38 }
                            ]}
                        >
                            {t("billprinttapshil.table.date")}
                        </Text>
                    ) : null}

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprinttapshil.table.liter")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprinttapshil.table.fat")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprinttapshil.table.snf")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed : styles.tableHeadersmbig2}>
                        {t("billprinttapshil.table.rate")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed2 : styles.tableHeadersmbig3}>
                        {t("billprinttapshil.table.amount")}
                    </Text>
                </View>

                {/* Table Data */}
                {tableDataWithZeros.map((entry, entryIndex) => (
                    <View key={entryIndex} style={styles.tableRow}>
                        {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                            <Text style={[bothornot === "both" ? styles.tableCell : styles.tableCellbig, { width: 38 }]}>
                                {entry.date.substr(5).split('-').reverse().join('/')}
                            </Text>
                        ) : null}
                        {
                            entry.liter === '0' ?
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}></Text>
                                </>
                                :
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.liter}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.fat}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.snf}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}>{parseFloat(entry.rate).toFixed(2)}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}>{parseFloat(entry.amt).toFixed(2)}</Text>
                                </>
                        }
                    </View>
                ))}
                {/* Totals Row */}
                <View style={styles.tableRow2}>
                    {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                        <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig, { width: bothornot === "both" ? 35 : 39 }]}>एकूण</Text>
                    ) : null}
                    <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{totalLiter.toFixed(1)}</Text>
                    {
                        localStorage.getItem("avg") === "On" ?
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgfat ? avgfat.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgsnf ? avgsnf.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig2]}>{avgrate ? avgrate.toFixed(2) : "0.0"}</Text>

                            </>
                            :
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig2]}>{"-"}</Text>

                            </>
                    }
                    <Text style={[bothornot === "both" ? styles.tableCellsmamt : styles.tableHeadersmbig3]}>{totalAmt.toFixed(2)}</Text>
                </View>
            </View>
        );
    };

    let dateflag = "";
    let bothornot = "";
    let milktype = "";

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";
    }


    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";
    }

    // Remaining combinations

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        //

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";
    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    const num = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
    };

    return (
        <>
            <Page
                key={index}
                size={localStorage.getItem("dur") === "10" ? "A4" : "A4"}
                orientation={localStorage.getItem("dur") === "10" ? "portrait" : "portrait"}
                style={styles.page}
            >
                {isGenerating ? (
                    <View style={styles.loading}>
                        <Text style={styles.headtextsmall3}>
                            {t("billprinttapshil.loading.generating", { min, sec })}
                        </Text>

                        <Text style={styles.headtextsmall4}>
                            {t("billprinttapshil.loading.totalPages", { pages })}
                        </Text>
                    </View>

                ) : (

                    <View>
                        <View style={styles.row1}>
                            <Text style={styles.headtextsmall}>
                                {t("billprinttapshil.header.account", {
                                    kno,
                                    name: knoData[0].cname,
                                })}
                            </Text>

                            <Text style={styles.headtextsmall2}>
                                {t("billprinttapshil.header.kendraCity", {
                                    kendra: knoData[0].kendra,
                                    city: localStorage.getItem("city"),
                                })}
                            </Text>

                            <Text style={styles.headtextsmall}>
                                {t("billprinttapshil.header.period", {
                                    from: formatDate(knoData[0].date1),
                                    to: formatDate(knoData[0].date2),
                                })}
                            </Text>
                        </View>

                        (
                        {
                            bothornot === "both" ?
                                <View>
                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmall}>{t("common.buffalo")}</Text>
                                        <Text style={styles.headtextsmall}>{t("common.cow")}</Text>
                                    </View>

                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmallleft1}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2}>{t("common.evening")}</Text>
                                        <Text style={styles.headtextsmallleft3}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft4}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                                :
                                <View>
                                    <View style={styles.row2single}>
                                        <Text style={styles.headtextsmall}>
                                            {milktype === "Buffalo"
                                                ? t("common.buffalo")
                                                : milktype === "Cow"
                                                    ? t("common.cow")
                                                    : milktype}
                                        </Text>
                                    </View>

                                    <View style={styles.row2both}>
                                        <Text style={styles.headtextsmallleft1big}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2big}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                        }
                        )


                        <View style={styles.tableContainer}>
                            {
                                ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey, tableIndex) => {
                                    const [type, time] = typeTimeKey.split('-'); // Split type and time
                                    const entries = groupByTypeAndTime[typeTimeKey];
                                    const tableDataWithZeros = getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);

                                    // Calculate totals
                                    const totalLiter = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.liter), 0);
                                    totalOfTotalLiter += totalLiter;


                                    const totalFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.fat), 0); // Sum up the fat values

                                    const totalEntriesWithFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgfat = totalFat / totalEntriesWithFat;

                                    const totalSNF = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.snf), 0); // Sum up the fat values

                                    const totalEntriesWithSNF = tableDataWithZeros
                                        .filter(entry => entry.snf > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgsnf = totalSNF / totalEntriesWithSNF;

                                    const totalRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.rate), 0); // Sum up the fat values

                                    const totalEntriesWithRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgrate = totalRate / totalEntriesWithRate;


                                    // tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0) + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0) + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0) + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) 
                                    tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0)
                                        + parseFloat(knoData[0].cthevitr1 !== null && !isNaN(knoData[0].cthevitr1) ? knoData[0].cthevitr1 : 0)
                                        + parseFloat(knoData[0].cthevitr2 !== null && !isNaN(knoData[0].cthevitr2) ? knoData[0].cthevitr2 : 0)
                                        + parseFloat(knoData[0].cthevitr3 !== null && !isNaN(knoData[0].cthevitr3) ? knoData[0].cthevitr3 : 0)
                                        + parseFloat(knoData[0].itrkapat1 !== null && !isNaN(knoData[0].itrkapat1) ? knoData[0].itrkapat1 : 0)
                                        + parseFloat(knoData[0].itrkapat2 !== null && !isNaN(knoData[0].itrkapat2) ? knoData[0].itrkapat2 : 0)
                                        + parseFloat(knoData[0].itrkapat3 !== null && !isNaN(knoData[0].itrkapat3) ? knoData[0].itrkapat3 : 0)
                                        + parseFloat(knoData[0].retan !== null && !isNaN(knoData[0].retan) ? knoData[0].retan : 0)
                                        + parseFloat(knoData[0].medi !== null && !isNaN(knoData[0].medi) ? knoData[0].medi : 0)
                                        + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0)
                                        + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? knoData[0].ratibkapat : 0)
                                        + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0)
                                        + parseFloat(knoData[0].karjhpta !== null && !isNaN(knoData[0].karjhpta) ? knoData[0].karjhpta : 0)
                                        + parseFloat(knoData[0].karjintr !== null && !isNaN(knoData[0].karjintr) ? knoData[0].karjintr : 0)
                                        + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) //+ parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0)


                                    {
                                        if (localStorage.getItem("billtype") === "oldbill") {
                                            tyene = num(knoData[0].newadv) + num(knoData[0].newkhadya) + num(knoData[0].newratib);
                                        } else {
                                            tyene = 0; // ✅ number
                                        }

                                    }

                                    ada = parseFloat(parseFloat(sumOfFifthTable) - parseFloat(tkapat) + parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0) + parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? (parseFloat(knoData[0].comm)) : 0)).toFixed(2);

                                    const totalAmt = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.amt), 0);

                                    dateflag = "";
                                    bothornot = "";

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";

                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    // Remaining combinations

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        //
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }

                                    }

                                })
                            }

                            <View style={styles.tableone}>
                                <View style={bothornot === "both" ? styles.tableHeaderone : styles.tableHeaderonebig}>

                                    <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebig}>
                                        {t("common.amount")}
                                    </Text>

                                </View>
                                {sumsOfAmtColumns.map((sum, entryIndex) => (

                                    <View key={entryIndex} style={bothornot === "both" ? styles.tableRowone : styles.tableRowonebig}>
                                        <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebigdata}>{sum.toFixed(2)}</Text>
                                    </View>
                                ))}

                                <View style={bothornot === "both" ? styles.allbill : styles.allbillbig}>
                                    <Text style={bothornot === "both" ? styles.tableCellone : styles.tableCellonebig2}>{sumOfFifthTable}</Text>
                                    {/* sumOfFifthTable */}
                                </View>
                            </View>
                        </View>



                        {localStorage.getItem("design") === "1" ? (
                            <View style={styles.row}>
                                <View style={styles.column2}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprinttapshil.deposit")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprinttapshil.advance")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprinttapshil.khady")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprinttapshil.ratib")}</Text>
                                </View>

                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>{"-"}</Text>
                                </View>

                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprinttapshil.bill")}</Text>
                                </View>
                            </View>
                        ) : (
                            ""
                        )}



                        <View style={styles.row}>
                            {/* ठेव */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column2 : styles.column2noborder}>
                                {
                                    localStorage.getItem("showthev") === "Yes"
                                        ? (localStorage.getItem("billtype") === "oldbill"
                                            ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].mthev !== null && !isNaN(knoData[0].mthev)
                                                            ? parseFloat(knoData[0].mthev).toFixed(2)
                                                            : 0}
                                                    </Text>
                                                </View>
                                            )
                                            : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? (knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0)
                                                            : (knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0)}
                                                    </Text>
                                                </View>
                                            )
                                        )
                                        : ""
                                }

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(
                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}

                                {
                                    localStorage.getItem("showthev") === "Yes"
                                        ? (localStorage.getItem("billtype") === "oldbill"
                                            ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.total")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (!isNaN(parseFloat(knoData[0].newthev)) ? parseFloat(knoData[0].newthev) : 0)
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            )
                                            : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.depositBox.total")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            parseFloat(localStorage.getItem("bcount")) > 0
                                                                ? parseFloat(knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0) +
                                                                parseFloat(
                                                                    parseFloat(
                                                                        parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                                        parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                                                    ).toFixed(2)
                                                                )
                                                                : parseFloat(knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0) +
                                                                parseFloat(
                                                                    parseFloat(
                                                                        parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                                        parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                                                    ).toFixed(2)
                                                                )
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            )
                                        )
                                        : ""
                                }
                            </View>


                            {/* एड्व्हांस  */}
                            {
                                localStorage.getItem("design") === "1" ?
                                    <>
                                        <View style={styles.column1}>
                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0)
                                                            : (knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0)}
                                                    </Text>
                                                </View>
                                            )}

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}
                                                </Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].cuchal) ? parseFloat(kapat[kno].cuchal).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newadv) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            parseFloat(localStorage.getItem("bcount")) > 0
                                                                ? (parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0) +
                                                                    parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) -
                                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                                : (parseFloat(knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0) +
                                                                    parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) -
                                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            )}
                                        </View>

                                        {/* खाद्य */}
                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? parseFloat(knoData[0].mkhadya).toFixed(2) : 0}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].ckhadya) ? parseFloat(kapat[kno].ckhadya).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newkhadya) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) -
                                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            )}
                                        </View>

                                        {/* रतीब */}
                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? parseFloat(knoData[0].mratib).toFixed(2) : 0}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>{knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0}</Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].ratibkapat) ? parseFloat(kapat[kno].ratibkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newratib) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.commonBox.balance")}</Text>
                                                </View>
                                            )}
                                        </View>
                                    </>

                                    :
                                    <>
                                        <View style={styles.column1noborder}>
                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(
                                                            parseFloat(
                                                                (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                (knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                            ).toFixed(2)
                                                        )}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? parseFloat(
                                                                parseFloat(
                                                                    (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                    (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)
                                                                ).toFixed(2)
                                                            )
                                                            : (knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0)}
                                                    </Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.khadyOn")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.khadyOnN")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.advanceOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.advanceOnN")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            )}

                                            {localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.ratibOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0).toFixed(2)}</Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.ratibOnN")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0).toFixed(2)}</Text>
                                                </View>
                                            )}
                                        </View>

                                        <View style={styles.column1noborder}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.totalBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(
                                                            parseFloat(
                                                                (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                (knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                            ) +
                                                            (knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                            (knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) +
                                                            (knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)
                                                        ).toFixed(2)
                                                    )}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.directDeduct")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        (
                                                            (knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                            (knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) +
                                                            (knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)
                                                        ).toFixed(2)
                                                    )}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.summaryBox.dueBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        (
                                                            parseFloat(
                                                                parseFloat(
                                                                    parseFloat(
                                                                        (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                        (knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                        (knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                                    ) +
                                                                    (knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                                    (knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) +
                                                                    (knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)
                                                                )
                                                            ) -
                                                            parseFloat(
                                                                parseFloat(
                                                                    (knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                                    (knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) +
                                                                    (knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)
                                                                )
                                                            )
                                                        ).toFixed(2)
                                                    )}
                                                </Text>
                                            </View>
                                        </View>
                                    </>

                            }


                            {/* एकूण */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprinttapshil.totalBox.liter")}</Text>
                                    <Text style={styles.column1Value}>{totalOfTotalLiter.toFixed(2)}</Text>
                                </View>

                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprinttapshil.totalBox.yene")}</Text>
                                    <Text style={styles.column1Value}>{tyene.toFixed(2)}</Text>
                                </View>

                                {localStorage.getItem("showother") === "Yes" ? (
                                    <>
                                        {parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) > 0 ? (
                                            localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.totalBox.otherDeductPerLiter")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprinttapshil.totalBox.otherDeductPerLiterN")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0}
                                                    </Text>
                                                </View>
                                            )
                                        ) : (
                                            ""
                                        )}

                                        {parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill) : 0) > 0 ? (
                                            <View style={styles.column1Row}>
                                                {/* name comes from localStorage, so no translation key */}
                                                <Text style={styles.column1Label}>{localStorage.getItem("itrmainname")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ) : (
                                    ""
                                )}
                            </View>

                            {/* बिल */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprinttapshil.billBox.totalBill")}</Text>
                                    <Text style={styles.column1Value}>{sumOfFifthTable}</Text>
                                </View>

                                {parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah) : 0) > 0
                                    ? localStorage.getItem("billtype") === "oldbill"
                                        ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.billBox.transportPlus")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah).toFixed(2)) : 0}
                                                </Text>
                                            </View>
                                        )
                                        : (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.billBox.transportPerLiterN")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                        ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                        : 0}
                                                </Text>
                                            </View>
                                        )
                                    : ""}

                                {parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm) : 0) > 0
                                    ? localStorage.getItem("billtype") === "oldbill"
                                        ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprinttapshil.billBox.commissionPlus")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].comm !== null && !isNaN(knoData[0].comm) ? (parseFloat(knoData[0].comm).toFixed(2)) : 0}
                                                </Text>
                                            </View>
                                        )
                                        : ""
                                    : ""}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.billBox.totalDeduct")}</Text>
                                        <Text style={styles.column1Value}>{parseFloat(tkapat).toFixed(2)}</Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.billBox.totalDeductN")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(
                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0) +
                                                parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                parseFloat(knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah) ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.billBox.netPayableOld")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprinttapshil.billBox.netPayableN")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(
                                                parseFloat(sumOfFifthTable) -
                                                parseFloat(
                                                    parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                    parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                    parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0) +
                                                    parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                    parseFloat(knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah) ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0)
                                                ).toFixed(2)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}
                            </View>

                        </View>
                        {/* <View style={styles.line} /> */}



                        {khArray.length > 0 && (
                            <>
                                <View style={styles.column1Rowtap}>
                                    <Text style={styles.textbold}>{t("billprinttapshil.khadyDetail.title")}</Text>
                                </View>

                                <View style={styles.khTable}>
                                    {/* HEADER */}
                                    <View style={styles.khTableHeader}>
                                        <Text style={[styles.khCell, styles.khtype]}>{t("billprinttapshil.khadyDetail.table.type")}</Text>
                                        <Text style={[styles.khCell, styles.khDate]}>{t("billprinttapshil.khadyDetail.table.date")}</Text>
                                        <Text style={[styles.khCell, styles.khName]}>{t("billprinttapshil.khadyDetail.table.name")}</Text>
                                        <Text style={[styles.khCell, styles.khQty]}>{t("billprinttapshil.khadyDetail.table.qty")}</Text>
                                        <Text style={[styles.khCell, styles.khRate]}>{t("billprinttapshil.khadyDetail.table.rate")}</Text>
                                        <Text style={[styles.khCell, styles.khAmt]}>{t("billprinttapshil.khadyDetail.table.amount")}</Text>
                                    </View>

                                    {/* ROWS */}
                                    {khArray.map((item, i) => (
                                        <View key={i} style={styles.khTableRow}>
                                            <View style={styles.khTableRow}>
                                                <Text style={[styles.khCell, styles.khtype]}>{item.type}</Text>
                                                <Text style={[styles.khCell, styles.khDate]}>{item.date}</Text>
                                                <Text style={[styles.khCell, styles.khName]}>{item.name}</Text>
                                                <Text style={[styles.khCell, styles.khQty]}>{item.quin}</Text>
                                                <Text style={[styles.khCell, styles.khRate]}>{item.rate}</Text>
                                                <Text style={[styles.khCell, styles.khAmt]}>{item.total}</Text>
                                            </View>
                                        </View>
                                    ))}
                                </View>
                            </>

                        )}


                        {advArray.length > 0 && (
                            <>
                                <View style={styles.column1Rowtap}>
                                    <Text style={styles.textbold}>{t("billprinttapshil.advanceDetail.title")}</Text>
                                </View>

                                <View style={styles.khTable}>
                                    <View style={styles.khTableHeader}>
                                        <Text style={[styles.khCell, styles.khDate]}>{t("billprinttapshil.advanceDetail.table.date")}</Text>
                                        <Text style={[styles.khCell, styles.khName]}>{t("billprinttapshil.advanceDetail.table.type")}</Text>
                                        <Text style={[styles.khCell, styles.khQty]}>{t("billprinttapshil.advanceDetail.table.amount")}</Text>
                                    </View>

                                    {advArray.map((item, i) => (
                                        <View key={i} style={styles.khTableRow}>
                                            <Text style={[styles.khCell, styles.khDate]}>{item.date}</Text>
                                            <Text style={[styles.khCell, styles.khName]}>{item.type}</Text>
                                            <Text style={[styles.khCell, styles.khQty]}>{item.amt}</Text>
                                        </View>
                                    ))}
                                </View>
                            </>

                        )}



                        {index < Object.keys(data).length - 1 && <Text style={styles.pageBreak} />}

                    </View>)}
            </Page>

        </>
    );

}

export default Billtapshil;
